import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { useContext } from 'react';
import SessionContext from '../../contexts/SessionContext';
import API_URL from '../../constants/environment';
import { PivotDomain, PivotStatsResponse } from '../../types/reporting';

const getPivotStats = async (
    sessionId: string,
    startDate: string,
    endDate: string,
    primaryDomain: PivotDomain,
    secondaryDomain: PivotDomain,
    excludeEvs?: boolean,
): Promise<PivotStatsResponse> => {
    const { data } = await axios.post<PivotStatsResponse>(
        `${API_URL}/reporting/pivot/stats`,
        { startDate, endDate, primaryDomain, secondaryDomain, excludeEvs },
        { headers: { Authorization: sessionId } }
    );
    return data;
};

export const usePivotStats = (
    startDate: string,
    endDate: string,
    primaryDomain: PivotDomain,
    secondaryDomain: PivotDomain,
    enabled = true,
    excludeEvs?: boolean,
) => {
    const sessionContext = useContext(SessionContext);

    return useQuery({
        queryKey: ['reporting', 'pivot', primaryDomain, secondaryDomain, startDate, endDate, excludeEvs],
        queryFn: () => getPivotStats(
            sessionContext?.sessionId ?? '',
            startDate,
            endDate,
            primaryDomain,
            secondaryDomain,
            excludeEvs,
        ),
        enabled: enabled && !!sessionContext?.sessionId && !!startDate && !!endDate,
        staleTime: 1000 * 60 * 5,
    });
};
